import Header from '../../components/Header'
import HeaderImg from '../../images/gallery-img.jpg'


import './gallery.css'

const Gallery = () => {
  const galleryLength = 8;
  const images = []

  for (let i = 0; i <= galleryLength; i++) {
    images.push(require(`../../images/Gallery_${i}.jpg`))
  }

  

  return (
    <>
        <Header title="Gallery" image={HeaderImg}>
          Consectetur adipiscing elit, sed do eiusmod tempor incididunt ut    labore et dolore magna aliqua.
        </Header>
        <section className="gallery">
          <div className="container gallery__container">
          {
            images.map((image,index) => {
           return <article key={index}>
            <img src={image} alt={`Gallery ${index +1}`} />
           </article>   
          })
          }
          </div>
          
        </section>
    </>
  )
}

export default Gallery